import React from 'react';
import { pasos } from '../data/content';
export function ComoEmpiezasSection() {
  return <section className="w-full bg-white px-4 py-9 sm:px-6 sm:py-12" data-id="element-32" data-mp="8tpv0ud12nq1">
      <div className="mx-auto max-w-2xl" data-id="element-33" data-mp="8qvaz3xxf4x5">
        <div className="text-center" data-id="element-34" data-mp="3qzmfu5jxkzkq">
          <h2 className="font-display text-[1.25rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-3xl" data-id="element-35" data-mp="3r0nok3dh59za">
            No tienes que cambiar todo de golpe.
          </h2>
          <p className="mt-2 text-[0.85rem] leading-snug text-gray-600 sm:text-base" data-id="element-36" data-mp="nimahchez30o">
            Abres Metabolismo Reset y comienzas paso a paso.
          </p>
        </div>

        <ol className="mt-5 space-y-0" data-id="element-37" data-mp="dr9jso7cqiw8">
          {pasos.map((paso, i) => <li key={paso.numero} className="flex gap-3" data-id="element-38" data-mp="iquj4zqfot9h" data-mpi={i}>
              <div className="flex flex-col items-center" data-id="element-39" data-mp="ipb236wyee6n">
                <span aria-hidden="true" className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand font-display text-[0.7rem] font-black text-white" data-id="element-40" data-mp="16fxax0es82hp">
                  {paso.numero}
                </span>
                {i < pasos.length - 1 && <span aria-hidden="true" className="my-1 w-px flex-1 bg-brand/25" data-id="element-41" data-mp="3addbhh5hst9z" />}
              </div>
              <div className="min-w-0 pb-4" data-id="element-42" data-mp="3jbf6ng2jorpc">
                <h3 className="font-display text-[0.95rem] font-extrabold uppercase leading-tight text-brand-deep sm:text-lg" data-id="element-43" data-mp="3jadybjcwyjbb">
                  {paso.titulo}
                </h3>
                <p className="mt-0.5 text-[0.82rem] leading-snug text-gray-600 sm:text-[0.95rem]" data-id="element-44" data-mp="3t1rxtr4v7j4g">
                  {paso.descripcion}
                </p>
              </div>
            </li>)}
        </ol>

        <p className="text-center font-display text-[0.95rem] font-extrabold uppercase leading-snug text-brand-deep sm:text-lg" data-id="element-45" data-mp="6sz8ft59bbot">
          No necesitas hacerlo perfecto.{' '}
          <span className="text-brand" data-id="element-46" data-mp="28nzsgcbxa3g2">
            Necesitas saber cuál es el siguiente paso.
          </span>
        </p>
      </div>
    </section>;
}